import "./style.css";

export const EventCard = ({
  month,
  day,
  weekday,
  title,
  subtitle,
  value,
  banner,
  link,
}) => {
  return (
    <div className="event-date_container d-flex">
      <div className="event-date">
        <div className="event-date__month">{month}</div>
        <div className="week">
          <div className="event-date__day">{day}</div>
          <div className="event-date__weekday">{weekday}</div>
        </div>
      </div>
      <div
        className="event-banner position-relative"
        style={{
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <a href={link} target="_blank" rel="noreferrer" className="d-block">
          <div className="event-banner__footer position-absolute">
            <div className="event-banner__title text-left">{title}</div>
            <div className="event-banner__footer-infos d-flex align-items-center">
              <div className="event-banner__footer-info d-flex align-items-center">
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <foreignObject x="0" y="0" width="0" height="0">
                    <div
                      xmlns="http://www.w3.org/1999/xhtml"
                      style={{
                        backdropFilter: "blur(0px)",
                        clipPath: "url(#bgblur_0_20_21840_clip_path)",
                        height: "100%",
                        width: "100%",
                      }}
                    ></div>
                  </foreignObject>
                  <path
                    data-figma-bg-blur-radius="0"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.45412 2.13363C3.08744 2.22432 2.83001 2.56225 2.83001 2.95078V6.37403V8.47131H2.32073C1.17252 8.47131 0.125241 9.32378 0.0113458 10.5018C-0.120143 11.8573 0.908616 13 2.19572 13H3.23189C4.41065 13 5.36533 12.0148 5.36533 10.8006V10.3863V8.47131V5.74303L10.4647 4.48962V7.25036H10.1054C8.95627 7.25036 7.90991 8.10188 7.79509 9.28082C7.6636 10.6364 8.69236 11.779 9.97947 11.779H10.8666C12.0453 11.779 13 10.7939 13 9.57866V9.16436V7.25036V3.85862V0.841086C13 0.296957 12.5065 -0.103981 11.9935 0.0239371L3.45412 2.13363Z"
                    fill="#C1C1C1"
                  />
                  <defs>
                    <clipPath
                      id="bgblur_0_20_21840_clip_path"
                      transform="translate(0 0)"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.45412 2.13363C3.08744 2.22432 2.83001 2.56225 2.83001 2.95078V6.37403V8.47131H2.32073C1.17252 8.47131 0.125241 9.32378 0.0113458 10.5018C-0.120143 11.8573 0.908616 13 2.19572 13H3.23189C4.41065 13 5.36533 12.0148 5.36533 10.8006V10.3863V8.47131V5.74303L10.4647 4.48962V7.25036H10.1054C8.95627 7.25036 7.90991 8.10188 7.79509 9.28082C7.6636 10.6364 8.69236 11.779 9.97947 11.779H10.8666C12.0453 11.779 13 10.7939 13 9.57866V9.16436V7.25036V3.85862V0.841086C13 0.296957 12.5065 -0.103981 11.9935 0.0239371L3.45412 2.13363Z"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <span className="d-block">{subtitle}</span>
              </div>
              <div className="event-banner__footer-info d-flex align-items-center">
                <svg
                  width="13"
                  height="14"
                  viewBox="0 0 13 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.51982 7.83916L5.62022 7.19141C5.24755 6.92377 5.16391 6.40519 5.43156 6.03346C5.69921 5.66079 6.21778 5.57622 6.58952 5.8448L7.48912 6.49255C7.86178 6.7602 7.94635 7.27877 7.67777 7.65051C7.41012 8.02224 6.89155 8.10681 6.51982 7.83916ZM9.91393 8.23786L10.3637 8.5622L12.8609 5.09391C13.0988 4.76306 13.0244 4.30118 12.6926 4.06327L11.6462 3.30865C11.4009 3.133 11.0617 3.10048 10.8172 3.27705C10.3247 3.63299 9.6407 3.6525 9.1212 3.27798C8.6017 2.90346 8.40282 2.24827 8.58404 1.66929C8.67419 1.3812 8.53572 1.06987 8.2913 0.893297L7.24394 0.139604C6.91309 -0.0992362 6.45121 -0.0239598 6.21237 0.306885L3.71617 3.77518L4.16597 4.09951C4.5377 4.36716 4.62227 4.88574 4.35462 5.25747C4.08697 5.62921 3.5684 5.71378 3.19574 5.44613L2.74594 5.12179L0.139143 8.74156C-0.0987672 9.07333 -0.0244201 9.53429 0.307354 9.77313L1.35379 10.5268C1.59913 10.7034 1.93834 10.7359 2.18276 10.5593C2.67531 10.2034 3.3593 10.1839 3.8788 10.5584C4.3983 10.9329 4.59718 11.5872 4.41596 12.1671C4.32581 12.4543 4.46428 12.7665 4.7087 12.9431L5.75606 13.6968C6.08691 13.9347 6.54879 13.8604 6.78763 13.5286L9.3935 9.90881L8.9437 9.58447C8.57196 9.31682 8.48739 8.79825 8.75504 8.42651C9.02269 8.05478 9.54126 7.97021 9.91393 8.23786Z"
                    fill="#C1C1C1"
                  />
                </svg>
                <span className="d-block">{value}</span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};
